import React, { Component } from 'react';
import { translate } from 'react-translate'
import { Link } from 'react-router-dom';
import Textblock from '../Components/Textblock';
import MassInfo from '../Components/MassInfo';
import PrayerInfo from '../Components/PrayerInfo';
import FullPageText from '../Components/FullPageText';
import ResponsiveImage from '../Components/ResponsiveImage';
import Iframe from 'react-iframe';


import ParteDuka from '../Images/duka/dominik-duka-parte.webp';
import Duka1 from '../Images/duka/001.jpg';
import Duka1Small from '../Images/duka/small/001.jpg';
import Duka2 from '../Images/duka/002.jpg';
import Duka2Small from '../Images/duka/small/002.jpg';
import Duka3 from '../Images/duka/003.jpg';
import Duka3Small from '../Images/duka/small/003.jpg';
import Duka4 from '../Images/duka/004.jpg';
import Duka4Small from '../Images/duka/small/004.jpg';
import Duka5 from '../Images/duka/005.jpg';
import Duka5Small from '../Images/duka/small/005.jpg';
import Duka6 from '../Images/duka/006.jpg';
import Duka6Small from '../Images/duka/small/006.jpg';
import Duka7 from '../Images/duka/007.jpg';
import Duka7Small from '../Images/duka/small/007.jpg';
import Duka8 from '../Images/duka/008.jpg';
import Duka8Small from '../Images/duka/small/008.jpg';
import Duka9 from '../Images/duka/009.jpg';
import Duka9Small from '../Images/duka/small/009.jpg';
import Duka10 from '../Images/duka/010.jpg';
import Duka10Small from '../Images/duka/small/010.jpg';
import Duka11 from '../Images/duka/011.jpg';
import Duka11Small from '../Images/duka/small/011.jpg';
import Duka12 from '../Images/duka/012.jpg';
import Duka12Small from '../Images/duka/small/012.jpg';
import Duka13 from '../Images/duka/013.jpg';
import Duka13Small from '../Images/duka/small/013.jpg';
import Duka14 from '../Images/duka/014.jpg';
import Duka14Small from '../Images/duka/small/014.jpg';
import Duka15 from '../Images/duka/015.jpg';
import Duka15Small from '../Images/duka/small/015.jpg';
import Duka16 from '../Images/duka/016.jpg';
import Duka16Small from '../Images/duka/small/016.jpg';
import Duka17 from '../Images/duka/017.jpg';
import Duka17Small from '../Images/duka/small/017.jpg';
import Duka18 from '../Images/duka/018.jpg';
import Duka18Small from '../Images/duka/small/018.jpg';
import Duka19 from '../Images/duka/019.jpg';
import Duka19Small from '../Images/duka/small/019.jpg';
import Duka20 from '../Images/duka/020.jpg';
import Duka20Small from '../Images/duka/small/020.jpg';
import Duka21 from '../Images/duka/021.jpg';
import Duka21Small from '../Images/duka/small/021.jpg';
import Duka22 from '../Images/duka/022.jpg';
import Duka22Small from '../Images/duka/small/022.jpg';
import Duka23 from '../Images/duka/023.jpg';
import Duka23Small from '../Images/duka/small/023.jpg';
import Duka24 from '../Images/duka/024.jpg';
import Duka24Small from '../Images/duka/small/024.jpg';
import Duka25 from '../Images/duka/025.jpg';
import Duka25Small from '../Images/duka/small/025.jpg';
import Duka26 from '../Images/duka/026.jpg';
import Duka26Small from '../Images/duka/small/026.jpg';
import Duka27 from '../Images/duka/027.jpg';
import Duka27Small from '../Images/duka/small/027.jpg';
import Duka28 from '../Images/duka/028.jpg';
import Duka28Small from '../Images/duka/small/028.jpg';
import Duka29 from '../Images/duka/029.jpg';
import Duka29Small from '../Images/duka/small/029.jpg';
import Duka30 from '../Images/duka/030.jpg';
import Duka30Small from '../Images/duka/small/030.jpg';
import Duka31 from '../Images/duka/031.jpg';
import Duka31Small from '../Images/duka/small/031.jpg';
import Duka32 from '../Images/duka/032.jpg';
import Duka32Small from '../Images/duka/small/032.jpg';
import Duka33 from '../Images/duka/033.jpg';
import Duka33Small from '../Images/duka/small/033.jpg';
import Duka34 from '../Images/duka/034.jpg';
import Duka34Small from '../Images/duka/small/034.jpg';
import Duka35 from '../Images/duka/035.jpg';
import Duka35Small from '../Images/duka/small/035.jpg';
import Duka36 from '../Images/duka/036.jpg';
import Duka36Small from '../Images/duka/small/036.jpg';
import Duka37 from '../Images/duka/037.jpg';
import Duka37Small from '../Images/duka/small/037.jpg';
import Duka38 from '../Images/duka/038.jpg';
import Duka38Small from '../Images/duka/small/038.jpg';

import SavioRozhovor from '../Images/savio/savio-rozhovor.jpg';

class Duka extends Component {
    render() {
        return (
            <div className="main-content">
                <div className="op-container animatedParent animateOnce">
                    <div className="row">
                        <div className="col-xs-12 col-sm-12 col-md-6">
                            <h1 className="main-title ">
                                P. Dominik Duka OP
                            </h1>

                        </div>
                        <div className="clearfix"></div>
                    </div>
                </div>
                <div className="history-photo-gallery margin-top-50 ">
                    <img src={Duka1Small} alt="Dominik Duka" data-caption="Dominik Duka" data-fancybox="gallery" href={Duka1} data-fancybox-group="all" />
                    <img src={Duka2Small} alt="Dominik Duka" data-caption="Dominik Duka" data-fancybox="gallery" href={Duka2} data-fancybox-group="all" />
                    <img src={Duka3Small} alt="Dominik Duka" data-caption="Dominik Duka" data-fancybox="gallery" href={Duka3} data-fancybox-group="all" />
                    <img src={Duka5Small} alt="Dominik Duka" data-caption="Dominik Duka" data-fancybox="gallery" href={Duka5} data-fancybox-group="all" />
                    <img src={Duka6Small} alt="Dominik Duka" data-caption="Dominik Duka" data-fancybox="gallery" href={Duka6} data-fancybox-group="all" />
                    <img src={Duka7Small} alt="Dominik Duka" data-caption="Dominik Duka" data-fancybox="gallery" href={Duka7} data-fancybox-group="all" />
                    <img src={Duka8Small} alt="Dominik Duka" data-caption="Dominik Duka" data-fancybox="gallery" href={Duka8} data-fancybox-group="all" />
                    <img src={Duka9Small} alt="Dominik Duka" data-caption="Dominik Duka" data-fancybox="gallery" href={Duka9} data-fancybox-group="all" />
                    <img src={Duka10Small} alt="Dominik Duka" data-caption="Dominik Duka" data-fancybox="gallery" href={Duka10} data-fancybox-group="all" />
                    <img src={Duka11Small} alt="Dominik Duka" data-caption="Dominik Duka" data-fancybox="gallery" href={Duka11} data-fancybox-group="all" />
                    <img src={Duka12Small} alt="Dominik Duka" data-caption="Dominik Duka" data-fancybox="gallery" href={Duka12} data-fancybox-group="all" />
                    <img src={Duka13Small} alt="Dominik Duka" data-caption="Dominik Duka" data-fancybox="gallery" href={Duka13} data-fancybox-group="all" />
                    <img src={Duka14Small} alt="Dominik Duka" data-caption="Dominik Duka" data-fancybox="gallery" href={Duka14} data-fancybox-group="all" />
                    <img src={Duka15Small} alt="Dominik Duka" data-caption="Dominik Duka" data-fancybox="gallery" href={Duka15} data-fancybox-group="all" />
                    <img src={Duka16Small} alt="Dominik Duka" data-caption="Dominik Duka" data-fancybox="gallery" href={Duka16} data-fancybox-group="all" />
                    <img src={Duka17Small} alt="Dominik Duka" data-caption="Dominik Duka" data-fancybox="gallery" href={Duka17} data-fancybox-group="all" />
                    <img src={Duka18Small} alt="Dominik Duka" data-caption="Dominik Duka" data-fancybox="gallery" href={Duka18} data-fancybox-group="all" />
                    <img src={Duka19Small} alt="Dominik Duka" data-caption="Dominik Duka" data-fancybox="gallery" href={Duka19} data-fancybox-group="all" />
                    <img src={Duka20Small} alt="Dominik Duka" data-caption="Dominik Duka" data-fancybox="gallery" href={Duka20} data-fancybox-group="all" />
                    <img src={Duka21Small} alt="Dominik Duka" data-caption="Dominik Duka" data-fancybox="gallery" href={Duka21} data-fancybox-group="all" />
                    <img src={Duka22Small} alt="Dominik Duka" data-caption="Dominik Duka" data-fancybox="gallery" href={Duka22} data-fancybox-group="all" />
                    <img src={Duka23Small} alt="Dominik Duka" data-caption="Dominik Duka" data-fancybox="gallery" href={Duka23} data-fancybox-group="all" />
                    <img src={Duka24Small} alt="Dominik Duka" data-caption="Dominik Duka" data-fancybox="gallery" href={Duka24} data-fancybox-group="all" />
                    <img src={Duka25Small} alt="Dominik Duka" data-caption="Dominik Duka" data-fancybox="gallery" href={Duka25} data-fancybox-group="all" />
                    <img src={Duka26Small} alt="Dominik Duka" data-caption="Dominik Duka" data-fancybox="gallery" href={Duka26} data-fancybox-group="all" />
                    <img src={Duka27Small} alt="Dominik Duka" data-caption="Dominik Duka" data-fancybox="gallery" href={Duka27} data-fancybox-group="all" />
                    <img src={Duka28Small} alt="Dominik Duka" data-caption="Dominik Duka" data-fancybox="gallery" href={Duka28} data-fancybox-group="all" />
                    <img src={Duka29Small} alt="Dominik Duka" data-caption="Dominik Duka" data-fancybox="gallery" href={Duka29} data-fancybox-group="all" />
                    <img src={Duka30Small} alt="Dominik Duka" data-caption="Dominik Duka" data-fancybox="gallery" href={Duka30} data-fancybox-group="all" />
                    <img src={Duka31Small} alt="Dominik Duka" data-caption="Dominik Duka" data-fancybox="gallery" href={Duka31} data-fancybox-group="all" />
                    <img src={Duka32Small} alt="Dominik Duka" data-caption="Dominik Duka" data-fancybox="gallery" href={Duka32} data-fancybox-group="all" />
                    <img src={Duka33Small} alt="Dominik Duka" data-caption="Dominik Duka" data-fancybox="gallery" href={Duka33} data-fancybox-group="all" />
                    <img src={Duka34Small} alt="Dominik Duka" data-caption="Dominik Duka" data-fancybox="gallery" href={Duka34} data-fancybox-group="all" />
                    <img src={Duka35Small} alt="Dominik Duka" data-caption="Dominik Duka" data-fancybox="gallery" href={Duka35} data-fancybox-group="all" />
                    <img src={Duka36Small} alt="Dominik Duka" data-caption="Dominik Duka - pohřeb Bartoloměje Kulhavého OP" data-fancybox="gallery" href={Duka36} data-fancybox-group="all" />
                    <img src={Duka37Small} alt="Dominik Duka" data-caption="Dominik Duka - pohřeb Bartoloměje Kulhavého OP" data-fancybox="gallery" href={Duka37} data-fancybox-group="all" />
                    <img src={Duka38Small} alt="Dominik Duka" data-caption="Dominik Duka - pohřeb Bartoloměje Kulhavého OP" data-fancybox="gallery" href={Duka38} data-fancybox-group="all" />
                </div>
                <ResponsiveImage img={ParteDuka} title="parte Duka" />


                 <div className="margin-top-60 margin-bottom-60">
                    <div className="long-description op-container animatedParent animateOnce ">
                    <div class="blocks">

                        <div class="block block-text">
                            <p><strong>Život Dominika kardinála Duky (zdroj https://apha.cz/novinky/odesel-kardinal-dominik-duka-op/)</strong></p>
                        </div>


                        <div class="block block-text">
                            <p>Dominik Duka (rodným jménem Jaroslav Václav Duka) se narodil 26. dubna roku 1943 v Hradci Králové otci Františku Dukovi a matce Anežce Dukové. František Duka se za 2. světové války účastnil zahraničního odboje a v roce 1944 jako člen vládního vojska odešel do Anglie, kde do konce války bojoval v Československé zahraniční armádě. V 50. letech byl spolu s důstojníky západní fronty vězněn. Po revoluci byl plně rehabilitován.</p>
                        </div>


                        <div class="block block-text">
                            <p>Jaroslav své první roky prožil s rodiči v Hradci Králové, kde studoval na Gymnáziu J. K. Tyla. Další studium mu bylo z kádrových důvodů znemožněno. Po maturitě pracoval v továrně ZVU, kde se vyučil strojním zámečníkem. Po absolvování základní vojenské služby v Trnavě mohl roku 1965 začít studovat teologii na Cyrilometodějské bohoslovecké fakultě v Litoměřicích.</p>
                        </div>


                        <div class="block block-text">
                            <p>5. ledna 1968 vstoupil tajně do dominikánského řádu a přijal řádové jméno Dominik. 6. ledna 1969 složil časné sliby. 22. června 1970 přijal kněžské svěcení z rukou kardinála Štěpána Trochty a pět let působil v duchovní správě pražské arcidiecéze.</p>
                        </div>


                        <div class="block block-text">
                            <p>Roku 1975 mu byl odebrán státní souhlas k výkonu duchovenské činnosti.</p>
                        </div>


                        <div class="block block-text">
                            <p>Poté pracoval patnáct let jako rýsovač v továrně Škoda-Plzeň. Intenzivně žil ilegální řádový život a věnoval se studiu.</p>
                        </div>


                        <div class="block block-text">
                            <p>Od roku 1975 do roku 1986 byl vikářem provinciála a současně v letech 1976–1981 magistrem kleriků.</p>
                        </div>


                        <div class="block block-text">
                            <p>V roce 1979 získal licenciát teologie na Papežské teologické fakultě sv. Jana Křtitele ve Varšavě.</p>
                        </div>


                        <div class="block block-text">
                            <p>V roce 1981 byl odsouzen za „maření státního dozoru nad církvemi“, za což byl patnáct měsíců vězněn v Plzni-Borech.</p>
                        </div>


                        <div class="block block-text">
                            <p>Po propuštění z vězení pracoval do roku 1989 ve Škodě Plzeň jako rýsovač. Roku 1988 byl tajně ustanoven provinciálem Českomoravské dominikánské provincie. Úřad vykonával 12 let.</p>
                        </div>


                        <div class="block block-text">
                            <p><strong>Život ve svobodě</strong></p>
                        </div>


                        <div class="block block-text">
                            <p>Po roce 1990 působil již veřejně jako provinciál dominikánského řádu. Souběžně s tím vyučoval na Cyrilometodějské teologické fakultě Univerzity Palackého v Olomouci a vykonával také úřad předsedy Konference vyšších řeholních představených. Byl iniciátorem českého překladu Jeruzalémské bible-vytvářeného od roku 1980-, a členem týmu překladatelů.</p>
                        </div>


                        <div class="block block-text">
                            <p>Podílel se výrazně jako šéfredaktor na vydávání dominikánské revue pro teologii, duchovní život a kulturu-Revue Salve.</p>
                        </div>


                        <div class="block block-text">
                            <p><strong>Biskupská služba</strong></p>
                        </div>


                        <div class="block block-text">
                            <p>6. června 1998 byl papežem Janem Pavlem II. jmenován 24. sídelním biskupem královéhradeckým a 26. září 1998 přijal biskupské svěcení z rukou arcibiskupa Karla Otčenáška v katedrále Svatého Ducha v Hradci Králové. Tuto funkci pak zastával až do roku 2010.</p>
                        </div>


                        <div class="block block-text">
                            <p>V&nbsp;Hradci Králové dokončil proces opravy nového Adalbertina a pozvedl rodiště sv. Vojtěch v&nbsp;Libici nad Cidlinou, kde nechal vybudovat nové sousoší sv. Vojtěcha a sv. Radima, i nový oltář. V&nbsp;době, kdy byl královéhradeckým biskupem, bylo opraveno rovněž poutní místo Luže. &nbsp;</p>
                        </div>


                        <div class="block block-text">
                            <p>Svatým otcem Janem Pavlem II. byl 6. listopadu 2004 jmenován i apoštolským administrátorem diecéze litoměřické. Úřad zastával do roku 2008.</p>
                        </div>


                        <div class="block block-text">
                            <p><strong>Arcibiskup a kardinál</strong></p>
                        </div>


                        <div class="block block-text">
                            <p>V sobotu 13. února 2010 byl jmenován nástupcem kardinála Miloslava Vlka ve funkci pražského arcibiskupa. Úřadu se ujal 10. dubna 2010 po své intronizaci v katedrále sv. Víta, Václava a Vojtěcha.</p>
                        </div>


                        <div class="block block-text">
                            <p>Dne 6. ledna 2012 oznámil papež Benedikt XVI., že arcibiskupa Duku ustanoví v blízké budoucnosti kardinálem. Oficiální ustanovení bylo následně provedeno při papežské konsistoři, která se konala dne 18. února 2012 v bazilice sv. Petra ve Vatikánu.</p>
                        </div>


                        <div class="block block-text">
                            <p>Během jeho působení na svatovojtěšském stolci se uskutečnilo majetkové narovnání státu s&nbsp;církvemi a byl ukončen soudní spor o katedrálu sv. Víta. Dominik Duka ji následně vybavil novým presbytářem, novým osvětlením a systémem katedrálních zvonů.</p>
                        </div>


                        <div class="block block-text">
                            <p>Zajistil též celkovou rekonstrukci poutních míst ve Staré Boleslavi a na Svaté Hoře u Příbrami. V&nbsp;době, kdy zastával úřad pražského arcibiskupa, rovněž vzniklo nové Komunitní centrum na pražském Barrandově a bylo zahájeno dílo v&nbsp;Žirči-charitní dílo, které pomáhá lidem s&nbsp;roztroušenou sklerózou.</p>
                        </div>


                        <div class="block block-text">
                            <p>Po celou dobu se kardinál Dominik Duka angažoval i v&nbsp;budování dobrých vztahů s&nbsp;ozbrojenými složkami a usiloval o budování duchovní péče v&nbsp;těchto složkách. Pravidelně navštěvoval věznice a setkával se s lidmi bez domova.&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;</p>
                        </div>


                        <div class="block block-text">
                            <p><strong>Rezignace</strong></p>
                        </div>


                        <div class="block block-text">
                            <p>Ve čtvrtek 26. dubna 2018, v den svých 75. narozenin, odevzdal, dle předpisů Kodexu církevního práva, kardinál Dominik Duka papeži Františkovi dopis, ve kterém rezignoval na post pražského arcibiskupa. Papež František jeho rezignaci přijal a zároveň Duku vyzval, aby úřad konal dále, dokud nebude stanoveno jinak. Jeho nástupcem v roce 2022 jmenoval papež František Jana Graubnera, v&nbsp;tu dobu arcibiskupa olomouckého.</p>
                        </div>


                        <div class="block block-text">
                            <p><strong>Ocenění</strong></p>
                        </div>


                        <div class="block block-text">
                            <p>Kardinál Duka byl držitelem mnoha vyznamenání. Obdržel mezi jinými Řád Bílého Lva za „zvláště vynikající zásluhy ve prospěch České republiky“ či francouzský Řád čestné legie. Byl držitelem i nejstaršího a nejvyššího polského státního vyznamenání Řádu bílé orlice.&nbsp; <strong>&nbsp;</strong></p>
                        </div>


                        <div class="block block-text">
                            <p>Kardinál Dominik Duka se ve svém působení opakovaně zajímal o otázky lidských práv a svobody ve světě. Ve svých prohlášeních a kázáních často připomínal, že důstojnost člověka je nedělitelná a musí být chráněna bez ohledu na náboženství, původ či politické přesvědčení. Zasazoval se zejména o svobodu vyznání a upozorňoval na pronásledování křesťanů v různých částech světa. Vystupoval také proti totalitním ideologiím a připomínal, že obrana lidských práv patří k základním úkolům církve i demokratické společnosti. Během celé své biskupské služby se zabýval česko-vatikánskou smlouvou.</p>
                        </div>


                        <div class="block block-text">
                            <p>Motto kardinála Dominika Duky bylo „In Spiritu Veritatis“ neboli „V duchu pravdy“.</p>
                        </div>
                    </div>
                </div>
                </div>
                {/* <ResponsiveImage img={SavioRozhovor} title="rozhovor" />
                    <div className='margin-top-50'>
                        <div className="video-iframe-wrapper-container">
                            <div className="video-iframe-wrapper">
                                <Iframe width="100%" url="https://www.youtube.com/embed/F3elWr1jc7Y" frameBorder="0" allowFullScreen></Iframe>
                            </div>
                        </div>
                    </div>
                    <div className='margin-top-50 margin-bottom-50'>
                        <div className="video-iframe-wrapper-container">
                            <div className="video-iframe-wrapper">
                                <Iframe width="100%" url="https://www.youtube.com/embed/DJ2nbL3TCp0" frameBorder="0" allowFullScreen></Iframe>
                            </div>
                        </div>
                    </div> */}
            </div>
        );
    }
}

export default translate("Duka")(Duka);